import styled from 'styled-components';
import { ModalRemovePxConfirmationStyled } from '../ModalRemovePxConfirmationStyled';
import { rem } from 'polished';

export const ModalRemovePxConfirmationStyledAP = styled(ModalRemovePxConfirmationStyled)`
    
`;
